import { useState, useEffect } from "react";

export function useEntityOrder<T extends { guid: string }>(entities: T[], key: string) {
    const [order, setOrder] = useState<string[]>(() => {
        try { return JSON.parse(sessionStorage.getItem(key) || "[]"); }
        catch { return []; }
    });

    useEffect(() => {
        if (!entities.length) return;
        const guids = entities.map(e => e.guid);
        const saved = order.filter(g => guids.includes(g));
        const merged = [...saved, ...guids.filter(g => !saved.includes(g))];

        if (merged.join() !== order.join()) {
            setOrder(merged);
            sessionStorage.setItem(key, JSON.stringify(merged));
        }
    }, [entities, order, key]);

    const move = (guid: string, dir: -1 | 1) => setOrder(prev => {
        const i = prev.indexOf(guid);
        if (i < 0) return prev;
        const j = i + dir;
        if (j < 0 || j >= prev.length) return prev;
        const next = [...prev];
        [next[i], next[j]] = [next[j], next[i]];
        sessionStorage.setItem(key, JSON.stringify(next));
        return next;
    });

    const ordered = order
        .map(g => entities.find(e => e.guid === g))
        .filter(Boolean) as T[];

    return { orderedEntities: ordered, moveUp: (g: string) => move(g, -1), moveDown: (g: string) => move(g, 1) };
}